export * from './domain';
export * from './testkit';
export * from './builders';
export * from './dto';
export var createOmnichannelDashboardApi = function (baseUrl, http) {
    var url = baseUrl + "/dashboard/omnichannel";
    return {
        getTableData: function (dashboardDto) { return http.post("" + url, dashboardDto); },
        getDashboardOverview: function (dashboardOverviewDto) { return http.post(url + "/overview", dashboardOverviewDto); },
    };
};
//# sourceMappingURL=index.js.map